import { Flex } from '@/components/ui/lib/flex';
import { Skeleton } from '@/components/ui/lib/skeleton';
import type { SkeletonTabBarProps } from '@/types/skeleton-tab-bar';

/**
 * The underline tab strip every tabbed page opens with. Rendered as placeholders rather
 * than as the real labels — the tabs are static text, but showing them before the page can
 * respond to a click would invite one.
 */
const SkeletonTabBar = ({ count, width = '6rem' }: SkeletonTabBarProps) => (
  <Flex gap="6" pb="3" mb="5" borderBottomWidth="1px" className="border-rim">
    {Array.from({ length: count }, (_, index) => (
      <Skeleton key={index} height="1rem" width={width} rounded="md" />
    ))}
  </Flex>
);

export default SkeletonTabBar;
